// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Icon_wrapper__2XJQW","pointer":"Icon_pointer__TZki5","expand":"Icon_expand__1GE6p","icon":"Icon_icon__390ps"};